

import React from "react"
import "./navigator-steps.scss"

const NavigatorSteps = props => {

    return (
        <div className="f-navigator-steps">
            <div onClick={()=>props.HandleStep(1)} className={props.step >= 1 ? props.step === 1 ? "f-navigator-steps-step f-navigator-steps-step-selected" : "f-navigator-steps-step f-navigator-steps-step-active" : "f-navigator-steps-step"}>1</div>
            <div onClick={()=>props.HandleStep(2)} className={props.step >= 2 ? props.step === 2 ? "f-navigator-steps-step f-navigator-steps-step-selected" : "f-navigator-steps-step f-navigator-steps-step-active" : "f-navigator-steps-step"}>2</div>
        </div>
    )
}

export default NavigatorSteps
